export default __webpack_public_path__ + "static/media/Punto_00_Darsena_Nuova_ITA_Def.0f94c67b.aac";